<template>
    <div class="border-medium radius-normal  mb-3 bg-lighter">
        <div class="d-flex justify-content-between align-items-end px-3 py-2 border-bottom-light">
            <div class="font-weight-600 darker py-2 col-sm-6">
                <div class="row flexGrow1">
                    <span v-if="widget.editing" class="w-100">
                        <div class="w-100">
                            <label class="pb-1">Name</label>
                            <input type="text" v-model="widget.name" class="w-100" placeholder="Widget Name"/>
                        </div>
                        
                        <div class="d-flex my-3">
                            <div class="mr-3 w-50">
                                <label>Google Tag Manager ID</label>
                                <input type="text" v-model="widget.gtagId" class="w-100" placeholder="GTM-XXXXXXX"/>
                            </div>

                            <div class="w-50">
                                <label>Google Analytics Measurement ID</label>
                                <input type="text" v-model="widget.googleAnalyticsMeasurementId" class="w-100" placeholder="G-XXXXXXX"/>
                            </div>
                        </div>
                        
                        <div class="my-3" :class="{ error: $v.widget.email.$error }">
                            <label class="w-100">
                                <span>Email - Booking notifications</span> <span class="normal fs-smaller">(you can enter multiple emails by separating them with comma ",")</span>
                                <input type="text" v-model="widget.email" @input="$v.widget.email.$touch" class="w-100" placeholder="email1@domain.com, email2@domain.com, email3@domain.com"/>
                            </label>

                            <div v-if="$v.widget.email.$error" class="messages">
                                <span v-if="!$v.widget.email.isEmailValid">Invalid email.</span>
                            </div>
                        </div>

                        <div class="col-sm-12 px-0 d-flex">
                            <div class="d-flex align-items-center py-2 pl-0 mt-3 pr-4">
                                <checkbox v-model="widget.isToSkipMyCart"></checkbox>
                                Hide "My Cart" step.
                            </div>

                            <div class="d-flex align-items-center py-2 pl-0 mt-3">
                                <checkbox v-model="widget.isToHidePromocode"></checkbox>
                                Hide Promocode.
                            </div>
                        </div>
                        
                        <div class="mt-3">
                            <div class="border-bottom mb-3 pb-1">Widget for a specific date:</div>

                            <div class="row">
                                <label class="col-sm-12 mr-3 d-inline-flex pb-1">Choose the date</label>
                                
                                <div class="col-sm-4">
                                    <DatePickerNew
                                        class="datepicker-align-left"
                                        v-model="singularEventDate"
                                        valueType="format">
                                    </DatePickerNew>
                                </div>

                                <div @click="removeWidgetDate" class="col-sm-1 pl-0 d-flex align-items-center"><i class="pointer ico ico-delete fs-smaller"></i></div>
                                
                                <div v-if="widget.singularEventDate != null && widget.singularEventDate != ''" class="col-sm-7 d-flex align-items-center">
                                    <checkbox v-model="widget.isToHideDate"></checkbox>Hide it on widget?
                                </div>
                            </div>
                        </div>
                    </span>

                    <span v-else>{{widget.name}}</span>
                </div>
            </div>

            <div class="d-flex" v-if="widget.loading">
                <loader></loader>
            </div>

            <div class="my-2" v-if="!widget.loading">
                <div v-if="isCreatingWidget == false" class="d-flex">
                    <button v-if="widget.editing" class="btn custom-widget save-btn font-weight-400 bg-color-3 lighter fs-smaller radius-normal pointer mr-2" @click="saveEditedWidget(widget)" :class="{'opacity-50 notAllowed': noProductsSelected}" :disabled="noProductsSelected"><i class="ico ico-check fs-smaller"></i>Save</button>
                    
                    <button v-if="widget.editing" class="btn custom-widget font-weight-400 bg-dark lighter fs-smaller radius-normal pointer mr-2" @click="cancelEditedWidget(widget)"><i class="ico ico-close fs-smaller"></i>Cancel</button>
                    
                    <button v-if="!widget.editing" class="btn custom-widget font-weight-400 bg-dark lighter fs-smaller radius-normal pointer mr-2" @click="activateEditionMode(widget)">
                        <div v-if="widget.isLoading">
                            <span>Loading</span>
                        </div>

                        <div class="d-flex align-items-center" v-else>
                            <i class="ico ico-edit fs-smaller"></i>
                            <span>Edit</span>
                        </div>
                    </button>

                    <button class="btn custom-widget delete-btn font-weight-400 bg-color-6 lightest fs-smaller radius-normal pointer" @click="deletThisWidget(widget)"><i class="ico ico-delete fs-smaller"></i>Delete</button>
                </div>

                <div v-if="isCreatingWidget == true">
                    <button class="btn custom-widget bg-color-3 lighter fs-smaller radius-normal pointer mr-2" @click="creatingSaveWidget(widget)" :class="{'opacity-50 notAllowed':validation.$invalid}"><i class="ico ico-check fs-smaller"></i>Save</button>
                    <button class="btn custom-widget bg-dark lighter fs-smaller radius-normal pointer mr-2" @click="creatingWidgetCancelWidget(widget)"><i class="ico ico-close fs-smaller"></i>Cancel</button>
                </div>
            </div>
        </div>

        <!-- Replaced with composer -->
        <div v-if="widget.editing && widget.categoryProductList" class="px-3 py-2">
            <div class="d-flex align-items-center">
                <div class="d-flex flex-grow-1 my-3">
                    <h3>Select items</h3>
                </div>
                <div class="d-flex">
                    <checkbox v-model="widget.isToActiveFutureItems"></checkbox>
                    <span>Allow new Products/Categories added to inventory to be automatically available in this widget.</span>
                </div>
            </div>
            <div class="error error-min-height">
                <span v-if="productsSelectedError">
                    Choose at least one product to save the changes.
                </span>
            </div>
            <widget-composer v-model="widget" :productOptions="productsArr" :showInputName="false"></widget-composer>
        </div>

        <div v-if="isCreatingWidget == false">
            <div class="fs-small font-weight-600 dark d-flex align-items-center justify-content-between px-3 pt-3">
                <div>
                    <span>This is the default code, you can costumize it to fit your website by pressing the "Preview and Costumize" button:</span>
                </div>
            </div>

            <div class="border-dark radius-normal bg-lightest m-3 p-2">
                <div class="fs-small position-relative">
                    {{generateIframeCode(widget.guid)}}
                </div>

                <div class="text-right">
                    <button class="copy-btn dark border-dark radius-normal align-items-center px-2 py-1 pointer bg-lightest fs-smaller" @click="copyWidget(widget)">
                        <i class="ico ico-notes fs-smaller"></i>
                        Copy
                    </button>
                </div>
            </div>

            <div class="m-3 d-flex justify-content-end align-items-center">
                <button v-tooltip="'Costumize the widget to better fit in your website'" class="btn preview-btn font-weight-600 bg-color-1 lightest fs-smaller radius-normal pointer" @click="costumizeWidget()">
                    <i class="far fa-eye fs-smaller"></i>Preview and Costumize
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    import extendedVSelect from '@/extends/vue-select'
    import Loader from '@/tools/loaders/loader1'
    import WidgetComposer from '@/tools/widget/widgetComposer'
    import DatePickerNew from '@/tools/DatePicker'

    export default {
        data() {
            return {
                productsArr: [],
                allProducts: {
                    name:'All Products',
                    allProducts: true
                }
            }
        },
        validations: {
            widget: {
                email: {
                    isEmailValid(val) {
                        return this.validateEmailString(val);
                    }
                }
            }
        },
        props: {
            widget: {
                type: Object
            },
            validation: {
                type: Object
            },
            isCreatingWidget: {
                type: Boolean,
                default: false
            },
            productOptions: {
                type: Array
            }
        },
        created() {
            this.productsArr = JSON.parse(JSON.stringify(this.productOptions));
        },
        computed: {
            ...mapGetters([
                'account',
                'getWidgets',
                'getSelectedWidgetCategory'
            ]),
            singularEventDate: {
                get() {
                    return this.widget.singularEventDate === null ? '' : this.widget.singularEventDate;
                },
                set(newValue) {
                    this.widget.singularEventDate = newValue;
                }
            },
            customQueryStringParameters(){
                const event_date = this.widget != undefined && this.widget.singularEventDate != undefined && this.widget.singularEventDate != '' ? '&event_date='+this.widget.singularEventDate : '';
                const skip_my_cart = this.widget != undefined && this.widget.isToSkipMyCart != undefined && this.widget.isToSkipMyCart != false ? '&skip_my_cart='+true : '';
                const hide_date = this.widget != undefined && this.widget.isToHideDate != undefined  && this.widget.isToHideDate != false ? '&hide_date='+this.widget.isToHideDate : '';

                return event_date+skip_my_cart+hide_date;
            },
            noProductsSelected() {
                return !(
                    Array.isArray(this.widget.categoryProductList) &&
                    this.widget.categoryProductList.some(category =>
                        Array.isArray(category.widgetProducts) &&
                        category.widgetProducts.some(product => product.isActive)
                    )
                    
                );
            },
            productsSelectedError() {
                return this.noProductsSelected;
            }
        },
        methods: {
            ...mapActions([
                'getAllWidgets',
                'createWidget',
                'deleteWidget',
                'updateWidget',
                'getSepcificWidget',
                'selecteWidget',
                'openModal',
            ]),
            removeWidgetDate() {
                this.singularEventDate = null;
                this.widget.isToHideDate = false;
            },
            validateEmailString(val) {
                if(!val || val == null || val == ""){
                    return false;
                }

                let isValid = true;
                let separator;
                
                if(val.includes(",")){
                    separator = ",";
                } else if (val.includes(";")) {
                    separator = ";";
                }
                let emailArray = val.split(separator);

                var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

                for (var i = 0; i < emailArray.length; i++) {
                    var email = emailArray[i].trim();
                    var thisEmailIsValid = re.test(email);
                    if(thisEmailIsValid === false){
                        isValid = false;
                    }
                }

                return isValid;
            },
            saveEditedWidget(widget) {
                this.$set(widget, 'loading', true);
                this.updateWidget(widget).then(response => {
                    this.$emit('refreshWidgetList');
                });
            },
            cancelEditedWidget(widget) {
                widget.editing = false;
            },
            creatingWidgetCancelWidget(widget) {
                this.$emit('creatingCancel');
            },
            creatingSaveWidget(widget) {
                if (this.validation.$invalid) {
                    return false;
                }

                this.$emit('creatingSave');
            },
            activateEditionMode(widget) {
                if (widget.isLoading && widget.isLoading == true) {
                    return false;
                }

                this.$set(widget, 'isLoading', true);

                this.getSepcificWidget(widget.id).then(downloadedWidget => {
                    for (var objKey in widget) {
                        if (downloadedWidget.hasOwnProperty(objKey)) {
                            this.$set(widget, objKey, downloadedWidget[objKey]);
                        }
                    }

                    this.$set(widget, 'isLoading', false);

                    if (!widget.editing) {
                        this.$set(widget, 'editing', true);
                    }
                })
            },
            deletThisWidget(widget) {
                this.deleteWidget(widget).then(response => {
                    this.$toasted.success(response.data);
                    this.$emit('refreshWidgetList');
                });
            },
            copyWidget(widget) {
                let widgetIframe = this.generateIframeCode(widget.guid);
                this.$clipboard(widgetIframe);
                this.$toasted.success('Widget code copied');
            },
            generateIframeCode(guid) {
                return '<iframe src="'+process.env.WIDGET_URL+'/?guid='+guid+this.customQueryStringParameters+'" width="400" height="600" style="position: relative;display: block;margin: auto;border: none;width: 100%;max-width: 400px;height: 100%; min-height: 450px; max-height: 600px;" allow="payment"></iframe>';
            },
            costumizeWidget() {
                let routeData = this.$router.resolve({ name: 'basic.costumize', params: {'widgetGuid':this.widget.guid + this.customQueryStringParameters } });
                window.open(routeData.href, '_blank');
            }
        },
        components:{
            vSelect: extendedVSelect,
            Loader,
            WidgetComposer,
            DatePickerNew
        }
    }
</script>

<style lang="scss" scoped>
    .error-min-height {
        min-height: 1.5em;
    }

    .copy-btn {
        height: 1.5625rem;
    }
    
    .preview-btn {
        padding: 0.25rem 0.65rem;
        height: 1.55rem;
        border: none;
    }

    button.btn.custom-widget {
        padding: 0.25rem 0.5rem;
        height: 1.45rem;
        border: none;
        box-shadow: none;  
    }
</style>

<style lang="scss">
    .btn.custom-widget {
        &:hover,
        &:focus,
        &:active {
            background-color: #8ca0b3 !important;
        } 
    }

    .btn.custom-widget.delete-btn {
        &:hover,
        &:focus,
        &:active {
            background-color: #f16c64 !important;
        }
    }

    .btn.custom-widget.save-btn {
        &:hover,
        &:focus,
        &:active {
            background-color: #6ac951 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// widgetEditor.vue?7d69e376